import { useState, useCallback } from 'react';

export function useImageViewer() {
  const [isOpen, setIsOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState({ url: '', alt: '' });

  const openImage = useCallback((url, alt = '') => {
    setCurrentImage({ url, alt });
    setIsOpen(true);
  }, []);

  const closeImage = useCallback(() => {
    setIsOpen(false);
  }, []);

  return {
    isOpen,
    currentImage,
    openImage,
    closeImage
  };
}